// Icon shown in the banner and section titles of every satellite page.
// Change the import to swap it, or export null to remove it.
import icon from '../../assets/icons/services/consultancy/banner_consultancy.svg';

export default icon;
